import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";

export class SaveAttemptErrorMatcher implements ErrorStateMatcher {
  constructor(private attemptSave: () => boolean) {}

  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = this.attemptSave();
    return !!(control && control.invalid && (control.touched || isSubmitted));
  }
}